import styled from 'styled-components';
import { buttonBase, getButtonAppearance, getIconButtonSize, getLoaderSize, iconButtonBase, } from 'modules/buttonStyles';
export const IconButtonContainer = styled.button `
  ${buttonBase}
  ${iconButtonBase}

  ${(props) => getButtonAppearance(props.appearance)};
  ${(props) => getIconButtonSize(props.size)};
  ${(props) => getLoaderSize(props.size)};
`;
